<template>
  <div class="logtimer">
    <input type="hidden" id="longitude" value="">
    <input type="hidden" id="latitude" value="">
    <input type="hidden" id="duty_status" value="">
    <input type="hidden" id="screen" value="">
    <section class="toolbar">
      <div class="toolbar-container">
        <router-link id="back-button-logtimer" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
        <h1>Logs</h1>
      </div>
    </section>
    <input type="hidden" id="progress" :value="progress_percentage" />
    <section class="driving-status">
      <div class="driving-status-container">
        <div class="driving-status-container-left">
          <span></span>
          <p>In Motion </p>
        </div>
        <div class="driving-status-container-right light-img">
          {{ selected_vehicle }}
          <img src="/static/images/eld-color.png">
        </div>
      </div>
    </section>
    <section class="meter">
      <div class="meter-img">
        <div id="container">
          <!--<img src="/static/images/meter.png">-->
        </div>
        <highcharts :options="options"></highcharts>
        <span>{{ hours }}:{{ minutes }}</span>
      </div>

      <div class="meter-status-container">
        <div class="meter-status">
          <img src="/static/images/miles.png">
          <span class="mileage-status">Calculating...</span>
        </div>

        <div class="divider"></div>
        <div class="meter-status">
          <img src="/static/images/driving.png"> Driving
        </div>
      </div>

    </section>
    <section class="submit-section">
      <button v-if="showPause" type="button" class="btn btn-default pause-btn" v-on:click="changeDuty('sb')" id="drive-pause">Pause</button>
      <button v-else type="button" class="btn btn-default start-btn" v-on:click="changeDuty('driving')" id="drive-start-again">Start</button>
      <button type="button" class="btn btn-default stop-btn" v-on:click="changeDuty('off')" id="drive-stop">OFF</button>
    </section>
    <div class="custom-loading" v-if="this.$config.loading">
      <div class="custom-loading-box">
         <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
      </div>
      </div>
    </body>
  </div>
  </div>
</template>
<script>

var intervalID = 0;
export default {
  name: "logtimer",
  data: () => ({
    selected_vehicle: "",
    //globalStatus="",
    userAgent: "",
    showPause: false,
    progress_percentage: "",
    hours: "00",
    minutes: "00",
    options: {
      chart: {
        type: "solidgauge",
        height: "110%",
        backgroundColor: "#047abc"
      },
      title: {
        text: "",
        style: {
          fontSize: "24px"
        }
      },
      tooltip: {
        borderWidth: 0,
        backgroundColor: "none",
        shadow: false,
        style: {
          fontSize: "16px"
        },
        pointFormat:
        '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}%</span>',
        positioner: function(labelWidth) {
          return {
            x: (this.chart.chartWidth - labelWidth) / 2,
            y: this.chart.plotHeight / 2 + 15
          };
        }
      },
      credits: {
        enabled: false
      },
      pane: {
        startAngle: -150,
        endAngle: 150,
        background: [
          {
            // Track for Move
            outerRadius: "100%",
            innerRadius: "90%",
            backgroundColor: "#047abc",
            borderWidth: 0
          }
        ]
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: "round",
          stickyTracking: false,
          rounded: false
        }
      },
      yAxis: {
        min: 0,
        max: 8,
        lineWidth: 2,
        tickPositions: [],
        plotBands: [
          {
            from: 0,
            to: 8,
            color: "transparent" // green
          },
          {
            from: 0,
            to: 5,
            color: "#DDDF0D"
          }
        ]
      },
      series: [
        {
          name: "",
          data: [0]
        }
      ]
    }
  }),

  mounted: function() {
    this.getUserAgent();
    this.call();
    intervalID = setInterval(function() {
      window.location.reload();
    }, 300000);
    console.log("in mounted");
    this.getELDStatus();
  },
  beforeDestroy: function() {
    clearInterval(intervalID);
  },
  methods: {
    getUserAgent: function() {
      this.userAgent = navigator.userAgent;
      console.log("UserAgent : " + this.userAgent);
    },
    getLocationConstant: function(flag) {
      var self = this;
      //self.$config.loading=true;
      if (navigator.geolocation) {
        var abc = navigator.geolocation.getCurrentPosition(
          self.onGeoSuccess,
          self.onGeoError,
          {enableHighAccuracy: true, timeout: 10000}
        );
        console.log(abc);
      } else {
        console.log("No GPS support");
      }
    },

    onGeoSuccess: function(event) {
      var self = this;
      //document.getElementById("location").value =  event.coords.latitude+", "+event.coords.longitude;
      $("#longitude").val(event.coords.longitude);
      $("#latitude").val(event.coords.latitude);
      self.changeDutystatus(event.coords.latitude, event.coords.longitude);
    },

    onGeoError: function(event) {
      var self = this;
      //alert("Error code " + event.code + ". " + event.message);
      console.log("Error code " + event.code + ". " + event.message);
      this.changeDutystatus("", "");
    },

    changeDutystatus: function(latitude, longitude) {
      var self = this;
      var status = $("#duty_status").val();
      var screen = $("#screen").val();
      console.log(status);
      $.ajax({
        url: self.$config.API + "/v1/operator/change-duty-status",
        type: "POST",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        data: { status: status, latitude: latitude, longitude: longitude },
        success: function(data) {self.$config.loading=false;

          // $(".loading").addClass("hide");

          if (screen == "home") {
            $(".duty-status a").removeClass("active");
            if (data.status == "success") {
              $(".duty-status")
                .find(".duty-" + status)
                .addClass("active");

              if (status == "driving") {
                $(".start-btn").prop("disabled", false);
                self.$router.push("/operator/log-timer");
              }
            } else {
              if (status == "driving") {
                $(".start-btn").prop("disabled", false);
              }
              console.log("1st-error");
            }
          } else {
            if (data.status == "success") {
              if (status == "sb") {
                $(".pause-btn").prop("disabled", false);
                $(".pause-btn").addClass("hide");
                $(".start-btn").removeClass("hide");
              }
              if (status == "driving") {
                $(".start-btn").addClass("hide");
                $(".pause-btn").removeClass("hide");
              }
              if (status == "off") {
                //self.$router.push("/operator/log-summary");
                self.$router.push("/operator/home-page");
                //window.location="/v1/operator/home-page";
              }
            } else {
              console.log("error");
            }
          }

        },
        error: function(jqXHR, exception,teststatus) {self.$config.loading=false;
          //if session expired
          if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }

        }
      });
    },

    /*
                Need to Query ELD Status only when Duty Status in 'on' or 'driving' or 'sb' in our System
            */
    getELDStatus: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/assets/get-current-status",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(data) {
          if (data.status == "success") {
            $(".driving-status-container-right").removeClass("light-img");
          } else {
            $(".driving-status-container-right").addClass("light-img");
          }
        },
        error: function(jqXHR, exception) {
          //if session expired
          if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else {
            console.log(jqXHR.responseJSON.message)
          }

        }
      });
    },

    /**
            * In the chart render event, add icons on top of the circular shapes
            */
    renderIcons: function() {
      // Move icon
      if (!this.series[0].icon) {
        this.series[0].icon = this.renderer
          .path(["M", -8, 0, "L", 8, 0, "M", 0, -8, "L", 8, 0, 0, 8])
          .attr({
            stroke: "#303030",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": 2,
            zIndex: 10
          })
          .add(this.series[2].group);
      }
      this.series[0].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 -
        this.series[0].points[0].shapeArgs.innerR -
        (this.series[0].points[0].shapeArgs.r -
          this.series[0].points[0].shapeArgs.innerR) /
        2
      );

      // Exercise icon
      if (!this.series[1].icon) {
        this.series[1].icon = this.renderer
          .path(["M", -8, 0, "L", 8, 0, "M", 0, -8, "L", 8, 0, 0, 8, "M", 8, -8, "L", 16, 0, 8, 8])
          .attr({
            stroke: "#ffffff",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": 2,
            zIndex: 10
          })
          .add(this.series[2].group);
      }
      this.series[1].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 -
        this.series[1].points[0].shapeArgs.innerR -
        (this.series[1].points[0].shapeArgs.r -
          this.series[1].points[0].shapeArgs.innerR) /
        2
      );

      // Stand icon
      if (!this.series[2].icon) {
        this.series[2].icon = this.renderer
          .path(["M", 0, 8, "L", 0, -8, "M", -8, 0, "L", 0, -8, 8, 0])
          .attr({
            stroke: "#303030",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": 2,
            zIndex: 10
          })
          .add(this.series[2].group);
      }

      this.series[2].icon.translate(
        this.chartWidth / 2 - 10,
        this.plotHeight / 2 -
        this.series[2].points[0].shapeArgs.innerR -
        (this.series[2].points[0].shapeArgs.r -
          this.series[2].points[0].shapeArgs.innerR) /
        2
      );
    },

    /*
        Need to Query asset covered miles from zonar system
    */
    getAssetMiles: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/assets/get-asset-distance-cover",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(res) {

          if (res.status == "success") {
            $(".mileage-status").text(res.data.distance + " Miles");
          } else {
            $(".mileage-status").text("0.00 Miles");
          }
        },
        error: function(jqXHR, exception) {

          //if session expired
          if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else {
            console.log(jqXHR.responseJSON.message)
          }
        }
      });
    },

    changeDuty: function(status) {
      var self = this;
      if (status == "sb") {
        // $(".pause-btn").prop("disabled", true);
        self.showPause = false;
      }
      if (status == "off") {
        // $(".stop-btn").prop("disabled", true);
      }
      if (status == "driving") {
        self.showPause = true;
        if (self.userAgent == "vtrleld_app") {
          Native.startLocationServices();
        }
      } else {
        if (self.userAgent == "vtrleld_app") {
          Native.stopLocationServices();
        }
      }

      //make empty last location
      $("#longitude").val("");
      $("#latitude").val("");
      $("#duty_status").val("");
      $("#screen").val("");

      $("#duty_status").val(status);
      $("#screen").val("log-timer");

      //disable screen on button click
      //$("body").addClass("overlay");
      //$(".loading").removeClass("hide");
      //get location of operator

      self.getLocationConstant();


    },

    call: function() {
      var self = this;
      //self.$config.loading=true;
      $.ajax({
        url: self.$config.API + "/v1/operator/log-timer",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(res) {self.$config.loading=false;

          var data = res.data;
          console.log(res)
          if (res.status == "success") {
            self.selected_vehicle = data.logData.selected_vehicle;
            self.progress_percentage = data.logData.progress_percentage;
            if (data.current_status == "driving") {
              self.showPause = true;
            }
            if (data.logData.hours.toString().length < 2) {
              self.hours = "0" + data.logData.hours
            } else {
              self.hours = data.logData.hours
            }
            if (data.logData.minutes.toString().length < 2) {
              self.minutes = "0" + data.logData.minutes
            } else {
              self.minutes = data.logData.minutes;
            }

            self.getAssetMiles();
            self.options.yAxis.max = parseFloat(data.logData.drive_time);
            self.options.yAxis.plotBands[0].to = parseFloat(data.logData.drive_time);
            self.options.yAxis.plotBands[1].to = parseFloat(data.logData.progress_percentage);
          }

        },
        error: function(jqXHR, exception,textstatus) {self.$config.loading=false;
          //if session expired
          if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.message)
          }

        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/logtimer.vue